import React, { useState } from 'react'
import { Image, Button, Container, Flex, Box, useDisclosure } from '@chakra-ui/react'
import logo from '../../assets/images/logo.png'
import { Link } from '@chakra-ui/react'
import MenuBar from './MenuBar'
import LoginModal from '../Login/LoginModal'
import ProfileModal from '../User/UserProfileModal'
import CustomButton from "../Button/CustomButton";

const Navbar = () => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('authUser');
    return saved ? JSON.parse(saved) : null;
  });
  const companyName = user ? user.company?.companyName : ''
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isProfileOpen, setProfileOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('authToken'));

  const logoUrl = user?.company?.logoUrl
  ? `${process.env.REACT_APP_BACKEND_URL}/api/auth/test-route?img=${user.company.logoUrl}`
  : '';


  const handleProfileOpen = () => setProfileOpen(true);
  const handleProfileClose = () => setProfileOpen(false);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('authUser');
    window.location.reload();
  };

  return (
      <Container maxW='7xl' py={2}>
        <Flex justifyContent={'space-between'} alignItems={'center'}>
          <Link href='https://www.spacephoto.co.uk'>
            <Image src={logo} alt='logo' />
          </Link>
          <Flex gap={6} display={{ base: 'none', md: 'flex' }}>
            <Link variant={'black-link'} href='https://www.spacephoto.co.uk/about-space-photo/'>About Us</Link>
            <Link variant={'black-link'} href='https://www.spacephoto.co.uk/products-services/'>Products And Services</Link>
            <Link variant={'black-link'} href='https://www.spacephoto.co.uk/portfolios/'>Portfolio</Link>
            <Link variant={'black-link'} href='/'>Shop</Link>
            <Link variant={'black-link'} href='https://www.spacephoto.co.uk/blog/'>Blog</Link>
            <Link variant={'black-link'} href='https://www.spacephoto.co.uk/contact-us/'>Contact Us</Link>
          </Flex>
          <Box display={{ base: 'none', md: 'block' }}></Box>
          <Box display={{ base: 'block', md: 'none' }}>
            <MenuBar setUser={setUser} />
          </Box>
        </Flex>

        {!isLoggedIn ? (
            <Box position="absolute" right={10} top="3%" transform="translateY(-50%)" display={{ base: 'none', md: 'block' }}>
              <Button variant="solid-green-btn" fontWeight={600} onClick={onOpen}>Trader's Account</Button>
            </Box>
        ) : (
            <>
              <Box position="absolute" right={10} top="3%" transform="translateY(-50%)" display={{ base: 'none', md: 'block' }}>
                <Button variant="solid-green-btn" fontWeight={600} onClick={handleLogout}>Logout</Button>
              </Box>
              <Box position="absolute" right="12rem" top="3%" transform="translateY(-50%)" display={{ base: 'none', md: 'block' }}>
                <Button
                    onClick={handleProfileOpen}
                    variant="outline"
                    fontWeight={600}
                    display="flex"
                    alignItems="center"
                    gap={2}
                    px={4}
                >
                  {logoUrl && (
                      <Image
                          src={logoUrl}
                          alt="Company Logo"
                          boxSize="30px"
                          borderRadius="full"
                          objectFit="cover"
                      />
                  )}
                  {companyName.length > 12 ? companyName.slice(0, 12) + '...' : companyName}
                </Button>
              </Box>
            </>
        )}

        <LoginModal isOpen={isOpen} onClose={onClose} setIsLoggedIn={setIsLoggedIn} setUser={setUser} />
        <ProfileModal isOpen={isProfileOpen} onClose={handleProfileClose} user={user} setUser={setUser} />
      </Container>
  )
}

export default Navbar
